import { useQuery, UseQueryResult } from 'react-query';
import { useTranslation } from 'react-i18next';
import { checkTemplateUsage } from '../sections/template-list/utils/queries';
import { ITemplate } from 'entities/template/template';

type UsageResponse = {
  isInUse: boolean;
};

export function useCheckTemplateUsage(
  template: ITemplate | null | undefined,
  enabled = true,
): UseQueryResult<UsageResponse, unknown> & { isInUse: boolean; isCheck404: boolean } {
  const { t } = useTranslation(['templates', 'designs', 'common']);

  const isEnabled = enabled && !!template?.siteId && !!template?.id && !!template?.channel;

  const queryKey = ['checkTemplateUsage', template?.siteId, template?.id, template?.channel, template?.type];

  const query = useQuery<UsageResponse, any>(
    queryKey,
    () => {
      if (!template) {
        throw new Error('Template is required for usage check');
      }
      return checkTemplateUsage({
        siteId: template.siteId,
        templateId: template.id,
        channel: template.channel,
        campaignType: template.type,
        t,
      });
    },
    {
      enabled: isEnabled,
      retry: (failureCount, error: any) => {
        if (error?.response?.status === 404) {
          return false;
        }
        return failureCount < 2;
      },
    },
  );

  const isInUse = query.data?.isInUse ?? false;
  const isCheck404 = query.isError && (query.error as any)?.response?.status === 404;

  return { ...query, isInUse, isCheck404 };
}
